/**
 * Toaster Component
 * iOS-first toast notifications using react-hot-toast
 * 
 * @author Varun Pandey
 */

import { useState, useEffect } from 'react';

export const Toaster = () => {
  const [HotToaster, setHotToaster] = useState<any>(null);

  useEffect(() => {
    // Dynamically import react-hot-toast
    import('react-hot-toast')
      .then((module) => {
        setHotToaster(() => module.Toaster);
      })
      .catch(() => {
        // Package not installed - Toaster will remain null
        console.warn('react-hot-toast not installed. Install it to see toast notifications.');
      });
  }, []);

  // If react-hot-toast is not installed, return null
  if (!HotToaster) {
    return null;
  }

  return (
    <HotToaster
      position="top-center"
      toastOptions={{
        duration: 3000,
        style: {
          background: '#2C2C2E',
          color: '#FFFFFF',
          borderRadius: '0.75rem',
          padding: '12px 16px',
          fontSize: '14px',
          fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, sans-serif',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
          border: '1px solid rgba(255, 255, 255, 0.1)',
        },
        success: {
          iconTheme: {
            primary: '#10B981',
            secondary: '#FFFFFF',
          },
        },
        error: {
          iconTheme: {
            primary: '#EF4444',
            secondary: '#FFFFFF',
          },
        },
      }}
    />
  );
};
